module.exports = __webpack_public_path__ + "img/plus-white.ec0046b7.svg";